import { useHeroCardForm } from "@/components/shared/forms/hero-card-form";
import type { CommonColor } from "@stackje/common/config";

export function AddHeroCard(defaultType: "hero1" | "hero2" | "hero3" | "hero4" | "hero5", defaultColors: CommonColor) {
  const { formContent, previewContent, toggleType, shuffleColors, handleSubmit } = useHeroCardForm({
    initialData: {
      brandTitle: "",
      title: "",
      description: "",
      socialLinks: [],
      type: defaultType,
      colors: defaultColors,
    },
    mode: "add",
  });

  return {
    formContent,
    previewContent,
    toggleType,
    shuffleColors,
    handleSubmit,
  };
}
